<div class="dropdown">
  <button class="btn btn-outline-success btn-round" type="button" (click)="onToggle()">Filter <i class="fa fa-filter"></i>
</button>
<form #filterForm='ngForm' (ngSubmit)='onFilter()'>

  <ul style="margin-top: 10px" class="filterBox filter" [class.show]="display" [appDraggable]="true">
    <h3 class="dropdown-header m-0 filter-header show">
      <span class="grey darken-2">Filter</span>
      <button data-dismiss="filter" aria-label="Close" (click)="onCloseFilter()" class="notification-tag float-right m-0 close">×</button>
    </h3>

    <li class="dropdown-header m-0">
      @if (details?.permission === 'super_admin') {
        <div class="form-group row">
          <label for="agent" class="col-sm-4 col-form-label">Agent Name</label>
          <div class="col-sm-8">
            <input type="text" class="form-control round" name="agent" id="agent" [(ngModel)]="model.agent">
          </div>
        </div>
      }
    </li>

    <li class="dropdown-header m-0">
      <div class="form-group row">
        <label for="amount_in_usd" class="col-sm-4 col-form-label">Amount in USD</label>
        <div class="col-sm-8">
          <input type="text" class="form-control round" id="amount_in_usd" name="amount_in_usd" [(ngModel)]="model.amount_in_usd">
        </div>
      </div>
    </li>

    <li class="dropdown-header m-0">
      <div class="form-group row">
        <label for="exchange_rate" class="col-sm-4 col-form-label">Exchange Rate</label>
        <div class="col-sm-8">
          <input type="text" class="form-control round" id="exchange_rate" name="exchange_rate" [(ngModel)]="model.exchange_rate">
        </div>
      </div>
    </li>

    <li class="dropdown-header m-0">
      <div class="form-group row">
        <label for="amount_in_naira" class="col-sm-4 col-form-label">Amount in Naira</label>
        <div class="col-sm-8">
          <input type="text" class="form-control round" id="amount_in_naira" name="amount_in_naira" [(ngModel)]="model.amount_in_naira">
        </div>
      </div>
    </li>


    <li class="dropdown-header m-0">
      <div class="form-group row">
        <label for="date" class="col-sm-4 col-form-label" >Date Added</label>
        <div class="col-sm-8">

          <div class="input-group btn-round">
            <div class="input-group-prepend">
              <span class="input-group-text">
                <i class="fa fa-calendar-o"></i>
              </span>
            </div>
            <input type='date' class="form-control pickadate btn-round" id="date" placeholder="Input Date"
              appDatePicker name="date" [(ngModel)]="model.date"/>
          </div>
        </div>
      </div>
    </li>
    <li class="dropdown-header m-0">
      <div class="form-group row">
        <div class="col-sm-4"></div>
        <div class="col-sm-12 pull-right">
          @if (clicked === true) {
            <i class="icons icon-loading pull-right"></i>
          }
          <button type="submit" class="btn btn-success btn-round pl-30 pr-30 pull-right">Filter</button>
          <button (click)='resetFilter()' class="btn reset pl-30 pr-30 pull-right">Reset</button>
        </div>
      </div>
    </li>
  </ul>
</form>
</div>
